import { AddBtn } from '@commonComponents/AddBtn'
import CustomCheckbox from '@commonComponents/formComponents/checkBox'
import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Table, TableHeader, TextArea, Header } from 'semantic-ui-react'
import { createNote, getNotesList } from '../../../commonApis/notesEvents'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import { convertEpochToUTC } from '../../../components/Helper/date'

const createNotesPayload = (description, hot, shipmentId, fullName) => {
  return {
    dateOfNote: { epochs: Date.now() },
    description: description,
    hot: hot,
    shipmentId: shipmentId,
    status: '0',
    userName: fullName,
  }
}

const NotesTab = ({ shipmentId, fullName, translate }) => {
  const [notesList, setNotesList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showCreateNote, setShowCeateNote] = useState(false)
  const [description, setDescription] = useState('')
  const [isHot, setIsHot] = useState(false)
  const [open, setOpen] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)

  useEffect(async () => {
    const response = await getNotesList(shipmentId)
    if (response?.data?.eventMessage?.shipmentNotesNodes) {
      setNotesList(response?.data?.eventMessage?.shipmentNotesNodes)
    }
    setIsLoading(false)
  }, [shipmentId])

  const saveNote = async () => {
    if (!description) {
      setIsEmpty(true)
      return
    }

    setIsEmpty(false)
    setIsLoading(true)
    const hot = isHot ? '1' : '0'
    const data = createNotesPayload(description, hot, shipmentId, fullName)

    const response = await createNote(data)
    if (response?.data?.eventMessage) {
      setDescription('')
      const newltCreatedNote = response?.data?.eventMessage
      setNotesList((prevNotes) => [newltCreatedNote, ...prevNotes])
      setIsHot(false)
    }
    setIsLoading(false)
  }

  const handleHotNote = async (hot, noteId) => {
    const data = {
      shipmentId,
      noteId,
      hot: hot == '0' ? '1' : '0',
    }
    const response = await createNote(data)
    if (response) {
      const newNotes = notesList.map((note) => {
        if (noteId == note?.noteId) {
          return { ...note, hot: response?.data?.eventMessage?.hot }
        } else {
          return note
        }
      })
      setNotesList(newNotes)
    }
  }

  const handleStatus = async (status, noteId, hot) => {
    const data = {
      shipmentId,
      noteId,
      status: status === '0' ? '1' : '1',
    }
    const response = await createNote(data)

    if (response) {
      const newNotes = notesList.map((note) => {
        if (noteId == note?.noteId) {
          return { ...note, status: response?.data?.eventMessage?.status }
        } else {
          return note
        }
      })
      setNotesList(newNotes)
    }

    if (Number(hot)) {
      setOpen(true)
    }
  }

  const handleCloseHotNote = async () => {
    setOpen(false)
    setIsLoading(true)
    const data = createNotesPayload(`Hot Note Closed - ${description}`, '0', shipmentId, fullName)
    const response = await createNote(data)
    if (response?.data?.eventMessage) {
      const newlytCreatedNote = response?.data?.eventMessage
      setNotesList((prevNotes) => [newlytCreatedNote, ...prevNotes])
      setDescription('')
    }

    setIsLoading(false)
  }

  return (
    <div className='notesTab'>
      <AddBtn
        onClick={() => setShowCeateNote((prevState) => !prevState)}
        disabled={isLoading}
        text={translate('ADD_NOTE')}
      />

      {showCreateNote && (
        <div className='notesHeader'>
          <div>
            <span>{translate('CREATED_BY')}:</span>
            <span className='userInfo'>{fullName}</span>
          </div>
          <div>
            <span>NOTE:</span>
            <Form>
              <TextArea
                className={isEmpty ? 'empty' : 'filled'}
                placeholder={translate('ADD_NOTES')}
                value={description}
                onChange={(e) => {
                  setIsEmpty(false)
                  setDescription(e.target.value)
                }}
              />
            </Form>
          </div>
          <div style={{ marginTop: '10px' }}>
            <span className='markHot'>
              <CustomCheckbox
                checked={isHot}
                label={translate('MARK_HOT_NOTE')}
                onClick={() => setIsHot((prev) => !prev)}
              />
            </span>
          </div>
          <Button color='blue' size='mini' disabled={isLoading} onClick={saveNote}>
            {translate('SAVE')}
          </Button>
          <Button
            color='blue'
            size='mini'
            disabled={isLoading}
            style={{ marginLeft: '50px' }}
            onClick={() => setShowCeateNote(false)}
          >
            {translate('CANCEL')}
          </Button>
        </div>
      )}

      {isLoading && <CustomLoader />}

      {notesList.length > 0 && (
        <div className='notesTable'>
          <Table celled>
            <TableHeader>
              <Table.Row>
                <Table.HeaderCell>{translate('STATUS')}</Table.HeaderCell>
                <Table.HeaderCell>{translate('DATE_TIME_UTC')}</Table.HeaderCell>
                <Table.HeaderCell>{translate('HOT_STATUS')}</Table.HeaderCell>
                <Table.HeaderCell>{translate('WHO')}</Table.HeaderCell>
                <Table.HeaderCell>{translate('NOTE')}</Table.HeaderCell>
              </Table.Row>
            </TableHeader>
            <Table.Body>
              {notesList.map((row, index) => {
                return (
                  <Table.Row key={row.noteId}>
                    <Table.Cell>
                      <span className='markHot'>
                        <CustomCheckbox
                          checked={Boolean(Number(row.status))}
                          label={
                            Boolean(Number(row.status)) ? translate('CLOSED') : translate('OPEN')
                          }
                          onChange={() => handleStatus(row.status, row.noteId, row.hot)}
                        />
                      </span>
                    </Table.Cell>
                    <Table.Cell>{convertEpochToUTC(row.dateOfNote.epochs)}</Table.Cell>
                    <Table.Cell disabled={Boolean(Number(row.hot))}>
                      <span className='markHot'>
                        <CustomCheckbox
                          checked={Boolean(Number(row.hot))}
                          label={
                            Boolean(Number(row.hot)) ? translate('HOT_NOTE') : translate('HOT')
                          }
                          onChange={() => handleHotNote(row.hot, row.noteId)}
                        />
                      </span>
                    </Table.Cell>
                    <Table.Cell>{row.userName}</Table.Cell>
                    <Table.Cell>{row.description}</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
        </div>
      )}

      {open && (
        <Modal
          style={{ width: '60%', top: '10%' }}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >
          <Header content={translate('CLOSE_HOT_NOTE')} />
          <Modal.Content style={{ width: '100%' }}>
            <Form>
              <TextArea
                style={{
                  padding:0,
                  outline:'none',
                  border:'1px solid rgb(91,156,206)'
                }}
                placeholder={translate('ADD_NOTES')}
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value)
                }}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color='black' onClick={() => setOpen(false)}>
              {translate('CANCEL')}
            </Button>
            <Button color='green' onClick={handleCloseHotNote}>
              {translate('SAVE')}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  )
}

export default React.memo(NotesTab)
